var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"position":"fixed","top":"0px","z-index":"9999998"}},[_c('Navbar')],1),_c('main',{staticStyle:{"margin-top":"60px"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }